import type { ReactStoryblokComponent } from "types/storyblok";
import type { SectionHeaderProps } from "modules/common/components/SectionHeader";
import { SectionHeader } from "modules/common/components";

const SectionHeaderAdapter = ({
  blok: { preheader, header, spacing, hAlignmentMobile, hAlignmentTablet, hAlignmentDesktop },
  sbEditable,
}: ReactStoryblokComponent<SectionHeaderProps>) => (
  <SectionHeader
    preheader={preheader}
    header={header}
    spacing={spacing}
    hAlignmentMobile={hAlignmentMobile}
    hAlignmentTablet={hAlignmentTablet}
    hAlignmentDesktop={hAlignmentDesktop}
    sbEditable={sbEditable}
  />
);

export default SectionHeaderAdapter;
